export enum ETransportIconType {
  groundOnly = 'groundOnly',
  airNonMao = 'airNonMao',
  airMao = 'airMao',
}
